import Vue from 'vue'
import {
	Tool
} from "./Tool.js";
import {
	getDeviceTypeName
} from './nativeOtherOperate.js'
import {
	Toast
} from 'vant'
Vue.use(Toast)

import JsBridge from "./JsBridge"

//plus 反射java实体类
var tool = null

function getCurrentTools() {
	if (!tool) {
		tool = Tool.getTools()
	}
	if (!tool) {
		return true
	}
	return false
}

//
export function initCert(userName) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			break;
		case 'plusiOS':
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':
			//tool.initCert(userName)
			break;
		default:

			break;
	}
}

//
export function getDownCertp10(corpName, creditCode, signetType, applyType, userName) {
	return new Promise((resolve, reject) => {
		let result = ''
		switch (getDeviceTypeName()) {
			case 'plusAndroid':
				if (getCurrentTools()) {
					reject('')
				}
				try {
					result = tool.getDownCertp10(plus.android.runtimeMainActivity(), userName, corpName,
						creditCode, signetType, applyType)
					resolve(result)
				} catch (err) {
					reject('未发现方法')
				}
				break;
			case 'plusiOS':
				if (getCurrentTools()) {
					reject('')
				}
				try {
					result = tool.getDownCertp10(userName, corpName, creditCode, signetType, applyType)
					resolve(result)
				} catch (err) {
					reject('未发现方法')
				}
				break;
			case 'Harmony':
				result = harmonyEsign.getDownCertp10(userName, corpName, creditCode, signetType, applyType)
				resolve(result)
				break;
			case 'Android':
				result = window.WebViewJavascriptBridge.getDownCertp10(userName, corpName, creditCode,
					signetType, applyType)
				resolve(result)
				break;
			case 'iOS':
				JsBridge.callHandler('getDownCertp10', {
					'userName': userName,
					'corpName': corpName,
					'creditCode': creditCode,
					'signetType': signetType,
					'applyType': applyType
				}, function (response) {
					console.log('getDownCertp10', response)
					resolve(response)
				})
				break;
			default:
				reject(0)
				break;
		}
	})
}

//
export function installCert(data, creditCode, signetType, userName) {
	return new Promise((resolve, reject) => {
		let result = ''
		switch (getDeviceTypeName()) {
			case 'plusAndroid':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.installCert(plus.android.runtimeMainActivity(), userName, data)
				resolve(result)
				break;
			case 'plusiOS':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.installCert(data, userName, creditCode, signetType)
				resolve(result)
				break;
			case 'Harmony':
				result = harmonyEsign.installCert(data, userName, creditCode, signetType)
				resolve(result)
				break;
			case 'Android':
				result = window.WebViewJavascriptBridge.installCert(data, userName, creditCode, signetType)
				resolve(result)
				break;
			case 'iOS':
				JsBridge.callHandler('installCert', {
					'certBase64': data,
					'userName': userName,
					'creditCode': creditCode,
					'signetType': signetType
				}, function (response) {
					console.log('installCert', response)
					resolve(response)
				})
				break;
			default:
				reject(0)
				break;
		}
	})
}

//
export function deleteCert(certSn, userName) {
	return new Promise((resolve, reject) => {
		let result = ''
		switch (getDeviceTypeName()) {
			case 'plusAndroid':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.deleteCert(plus.android.runtimeMainActivity(), userName, certSn)
				resolve(result)
				break;
			case 'plusiOS':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.deleteCert(certSn, userName)
				resolve(result)
				break;
			case 'Harmony':
				result = harmonyEsign.deleteCert(certSn, userName)
				resolve(result)
				break;
			case 'Android':
				result = window.WebViewJavascriptBridge.deleteCert(userName, certSn)
				resolve(result)
				break;
			case 'iOS':
				JsBridge.callHandler('deleteCert', {
					'certSn': certSn,
					'userName': userName
				}, function (response) {
					console.log('deleteCert', response)
					resolve(response)
				})
				break;
			default:
				reject(0)
				break;
		}
	})
}

//
export function getLocalCertList(userName) {
	return new Promise((resolve, reject) => {
		let result = ''
		switch (getDeviceTypeName()) {
			case 'plusAndroid':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.getLocalCertList(plus.android.runtimeMainActivity(), userName)
				resolve(result)
				break;
			case 'plusiOS':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.getLocalCertList(userName)
				resolve(result)
				break;
			case 'Harmony':
				result = harmonyEsign.getLocalCertList(userName)
				resolve(result)
				break;
			case 'Android':
				result = window.WebViewJavascriptBridge.getLocalCertList(userName)
				resolve(result)
				break;
			case 'iOS':
				JsBridge.callHandler('getLocalCertList', {
					'userName': userName
				}, function (response) {
					console.log('getLocalCertList', response)
					resolve(response)
				})
				break;
			default:
				reject(0)
				break;
		}
	})
}

//
export function getSealHashSign(certSn, signingPkcs, userName) {
	return new Promise((resolve, reject) => {
		let result = ''
		switch (getDeviceTypeName()) {
			case 'plusAndroid':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.getSealHashSign(plus.android.runtimeMainActivity(), userName, certSn, signingPkcs)
				resolve(result)
				break;
			case 'plusiOS':
				if (getCurrentTools()) {
					reject('')
				}
				result = tool.getSealHashSign(certSn, signingPkcs, userName)
				resolve(result)
				break;
			case 'Harmony':
				result = harmonyEsign.getSealHashSign(certSn, signingPkcs, userName)
				resolve(result)
				break;
			case 'Android':
				result = window.WebViewJavascriptBridge.getSealHashSign(userName, certSn, signingPkcs)
				resolve(result)
				break;
			case 'iOS':
				JsBridge.callHandler('getSealHashSign', {
					'certSn': certSn,
					'signingPkcs': signingPkcs,
					'userName': userName
				}, function (response) {
					console.log('getSealHashSign', response)
					resolve(response)
				})
				break;
			default:
				reject(0)
				break;
		}
	})
}

export function saveEventCertPath(userName, data) {
	return new Promise((resolve, reject) => {
		if (getDeviceTypeName() === 'Android') {
			let path = window.WebViewJavascriptBridge.saveEventCertPfxPath(userName, data.privateKey, data
				.certPem)
			resolve(path)
		} else if (getDeviceTypeName() === 'iOS') {
			JsBridge.callHandler(
				'saveEventCertPfxPath', {
				userName: userName,
				privateKey: data.privateKey,
				certPem: data.certPem
			},
				function (responseData) {
					console.log('-WebViewJavascriptBridge-saveEventCertPath', responseData)
					resolve(responseData)
				}
			)
		} else if (getDeviceTypeName() === 'Harmony') {
			let path = harmonyEsign.saveEventCertPfxPath(data.privateKey, data.certPem)
			resolve(path)
		}
	})
}

export function getSealCertPath(userName, certSn) {
	return new Promise((resolve, reject) => {
		if (getDeviceTypeName() === 'Android') {
			let path = window.WebViewJavascriptBridge.getSealCertPfxPath(userName, certSn)
			resolve(path)
		} else if (getDeviceTypeName() === 'iOS') {
			JsBridge.callHandler(
				'getSealCertPfxPath', {
				userName: userName,
				certSn: certSn
			},
				function (responseData) {
					console.log('-WebViewJavascriptBridge-getSealCertPath', responseData)
					resolve(responseData)
				}
			)
		} else if (getDeviceTypeName() === 'Harmony') {
			let path = harmonyEsign.getSealCertPfxPath(certSn)
			resolve(path)
		}
	})
}